import { useQuery } from '@tanstack/react-query';
import { TwoFaStatusEntity, UserWalletAuthService } from 'services/openapi';

import { AuthQueryKeys } from './constants';

export const useGetTwoFaStatusQuery = (enabled: boolean = true) => {
  const queryKey = [AuthQueryKeys.GET_TWO_FA_STATUS];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<TwoFaStatusEntity, Error>({
    queryKey,
    queryFn: () => UserWalletAuthService.authControllerGetTwoFaStatus(),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
